import clsx from 'clsx';
import React, { FC } from 'react';

interface HrComponentProps {
  height?: number;
  className?: string;
}

const Hr: FC<HrComponentProps> = ({
  height = 1,
  className,
}) => {
  const style = {
    height,
  };

  return <div className={clsx('divider', className)} style={style} />;
};

export default Hr;
